class Cv {
  constructor(config = {}) {
    const {
      cvSelector,
    } = config;

    this.cvSelector = cvSelector;
    this.cvs = Array.prototype.slice.call(document.querySelectorAll(this.cvSelector));

    if (this.cvs && this.cvs.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.cvs.forEach(item => {

      let body = document.body;
      let backdrop = document.querySelector('.iz-backdrop');

      let button = item.querySelector('.lc-cv__header');
      let overlay = item.querySelector('.lc-cv__content');
      let content = item.querySelector('.lc-cv__content-column');

      let portrait = item.querySelector('.lc-cv__header-portrait').cloneNode(true);
      let header = item.querySelector('.lc-cv__header-content').cloneNode(true);
      let headerName = item.querySelector('.lc-cv__header-content .lc-title-h3__text').textContent;

      overlay.prepend(portrait);
      content.prepend(header);
      item.querySelector('.lc-cv__content-header-name').textContent = headerName;

      let buttonClose = overlay.querySelector('.lc-cv__content-header-button');

      button.addEventListener('click', () => {
        body.classList.add('cv-open');
        overlay.classList.add('lc-cv__content--active');
        overlay.classList.add('lc-cv__content--visible');
      });

      buttonClose.addEventListener('click', () => {
        this.closeOverlay(body, overlay);
      });

      if (!backdrop) {
        return;
      }

      backdrop.addEventListener('click', () => {
        this.closeOverlay(body, overlay);
      });
    });
  }

  closeOverlay(body, overlay) {
    body.classList.remove('cv-open');
    overlay.classList.remove('lc-cv__content--active');
    setTimeout(() => {
      overlay.classList.remove('lc-cv__content--visible');
    },410);
  }
}

export default Cv;
